export default __webpack_public_path__ + "31aa9dcf43c0fc76e432c4f86cce66bd.png";